import type Dashboard from 'modules/reports/store/models/Dashboard'
import Projection from 'modules/reports/store/models/Projection'
import Report from 'modules/reports/store/models/Report'
import type Template from 'modules/reports/store/models/Template'

const reportFromTemplate = (template: Template, dashboard: Dashboard): Report => {
  const templateObj = template.toJS()

  // Here we are going to override projections and filters for reports
  // model since in the case of templates we are not going to get them
  // from remote API

  const projections = template.projections.map(
    (projection: Projection) => new Projection(projection.toJS())
  )

  const filters = template.filters

  const reportParams = {
    title: templateObj.title,
    chart_type: templateObj.type,
    projections: projections,
    filters: filters,
    dashboard_id: dashboard.attributes.id,
    sql_query: template.sqlQuery,
    sql_configuration: templateObj.sql_configuration,
  }

  return new Report(reportParams)
}

export default reportFromTemplate
